// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function YoutubeLogoBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="m21.311 14.739-7-4.5A1.5 1.5 0 0 0 12 11.5v9a1.5 1.5 0 0 0 2.311 1.261l7-4.5a1.5 1.5 0 0 0 0-2.522ZM15 17.75v-3.5L17.726 16 15 17.75Zm14.776-9.188A3.507 3.507 0 0 0 27.66 6.17C23.3 4.489 16.411 4.5 16 4.5c-.411 0-7.3-.011-11.66 1.673a3.506 3.506 0 0 0-2.116 2.392C1.894 9.84 1.5 12.165 1.5 16c0 3.835.394 6.16.724 7.435a3.506 3.506 0 0 0 2.116 2.393C8.526 27.444 15.045 27.5 15.921 27.5h.158c.875 0 7.395-.056 11.581-1.672a3.506 3.506 0 0 0 2.116-2.393c.33-1.275.724-3.6.724-7.435 0-3.835-.394-6.16-.724-7.435v-.002Zm-2.901 14.12a.499.499 0 0 1-.293.347C22.848 24.47 16.535 24.5 16.04 24.5h-.049c-.066 0-6.705.021-10.57-1.471a.501.501 0 0 1-.296-.346C4.89 21.777 4.5 19.704 4.5 16c0-3.705.394-5.777.625-6.682a.5.5 0 0 1 .293-.347C9.286 7.48 15.924 7.5 15.99 7.5h.019c.067 0 6.705-.021 10.57 1.471a.5.5 0 0 1 .296.347c.235.905.625 2.977.625 6.682 0 3.705-.394 5.777-.625 6.683Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
